/**
 * Leitura dos endereços do cliente no Cliente 360 (ADR-0071).
 *
 * O cockpit manda `cliente.enderecos` na ordem (o 1º é o principal; `cobranca`
 * marca o de cobrança) e não traz mais `cidade`/`estado` soltos — ler a chave
 * antiga dá `undefined` e o dado some da tela sem erro. A linha completa de
 * um endereço sai de `formatarEndereco` (utils/endereco).
 */

export function enderecosDoCliente(cliente) {
  return Array.isArray(cliente?.enderecos) ? cliente.enderecos : [];
}

export function enderecoPrincipal(cliente) {
  return enderecosDoCliente(cliente)[0] || null;
}

/** "Cidade · UF" do chip do topo; só o que existe entra. */
export function cidadeUf(endereco) {
  return [endereco?.cidade, endereco?.estado]
    .map((parte) => String(parte ?? "").trim())
    .filter(Boolean)
    .join(" · ");
}
